<div id="wrapper">
  <div>
    <span class="searchCond">
      <mat-label>Search By Upload Time (UTC) : </mat-label>
      <input type="datetime-local" [(ngModel)]="searchCond.startDate" matInput>
      <mat-label>~</mat-label>
      <input type="datetime-local" [(ngModel)]="searchCond.endDate" matInput>
    </span>
    <span class="searchCond">
      <mat-label>MessageId : </mat-label>
      <input type="text" [(ngModel)]="searchCond.messageId" matInput>
    </span>
    <span class="searchCond">
      <mat-label>Sort Order : </mat-label>
      <mat-radio-group [(ngModel)]="searchCond.sortOrder">
        <mat-radio-button value="ASC">ASC</mat-radio-button>
        <mat-radio-button value="DESC">DESC</mat-radio-button>
      </mat-radio-group>
    </span>  
    <button (click)="onSearch()" color="primary" mat-raised-button  class="action-button">
      Search
    </button>
    <button (click)="onUpload()" color="primary" mat-raised-button  class="action-button">
      Upload
    </button>
    <button (click)="onDownloadCsvFile()" color="primary" mat-raised-button  class="action-button">
      CSV Download
    </button>
  </div>
  <div *ngIf="fileStatusResponse$ | async as fileStatusResponse" >
    <!-- paginator -->
    <mat-paginator [length]="fileStatusResponse.count" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons (page)="onPageChange($event)">
    </mat-paginator>
    <table mat-table [dataSource]="fileStatusResponse.result" class="mat-elevation-z8">
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef scope="col">NO</th>
        <!--<td mat-cell *matCellDef="let item">{{item.no}}</td>-->
        <td mat-cell *matCellDef="let item; let i = index"> {{ pageIndex * pageSize + i + 1 }} </td>
      </ng-container>

      <ng-container matColumnDef="fileId">
        <th mat-header-cell *matHeaderCellDef scope="col">File Id</th>
        <td mat-cell *matCellDef="let item">{{item.fileId}}</td>
      </ng-container>

      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef scope="col">File Name</th>
        <td mat-cell *matCellDef="let item">{{item.fileName}}</td>
      </ng-container>

      <ng-container matColumnDef="messageId">
        <th mat-header-cell *matHeaderCellDef scope="col">MessageId</th>
        <td mat-cell *matCellDef="let item">
          <a
            class="link"
            href="javascript:void(0)"
            (click)="onDownloadSendFile(item.messageId)">
            {{item.messageId}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="uploadTime">
        <th mat-header-cell *matHeaderCellDef scope="col">Upload Time (UTC)</th>
        <td mat-cell *matCellDef="let item" class="table-td-uploadTime">{{item.uploadTime}}</td>
      </ng-container>

      <ng-container matColumnDef="uploadStatus">
        <th mat-header-cell *matHeaderCellDef scope="col">Upload Status</th>
        <td mat-cell *matCellDef="let item">{{item.uploadStatus}}</td>
      </ng-container>

      <ng-container matColumnDef="sendTime">
        <th mat-header-cell *matHeaderCellDef scope="col">Send Time (UTC)</th>
        <td mat-cell *matCellDef="let item">{{item.sendTime}}</td>
      </ng-container>

      <ng-container matColumnDef="feedbackMessageId">
        <th mat-header-cell *matHeaderCellDef scope="col">Feedback MessageId</th>
        <td mat-cell *matCellDef="let item">
          <a
            class="link"
            href="javascript:void(0)"
            (click)="onDownloadFeedbackFile(item.feedbackMessageId)">
            {{item.feedbackMessageId}}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="feedbackTime">
        <th mat-header-cell *matHeaderCellDef scope="col">Feedback Time (UTC)</th>
        <td mat-cell *matCellDef="let item">{{item.feedbackTime}}</td>
      </ng-container>
      
      <ng-container matColumnDef="feedbackFirstDownloadTime">
        <th mat-header-cell *matHeaderCellDef scope="col">Feedback<br>First Download</th>
        <td mat-cell *matCellDef="let item">{{item.feedbackFirstDownloadTime}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns" class="table-header"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
  </div>
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>
